import script from "./FleetLogsBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./FleetLogsBoard.vue?vue&type=script&setup=true&lang=js"

import "./FleetLogsBoard.vue?vue&type=style&index=0&id=6790f19a&lang=scss"

const __exports__ = script;

export default __exports__